export default __webpack_public_path__ + "static/media/Permissions.68380c45.svg";